import axios from "axios";

const apiInstance = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL || "",
    transformResponse: [(data) => {
        if (typeof data === "string") {
            try {
                return JSON.parse(data);
            } catch (e) {
                return data;
            }
        }
        return data;
    }]
});

apiInstance.interceptors.request.use(async (config) => {
    config.headers.key = process.env.REACT_APP_API_KEY || "";
    config.headers["Content-Type"] = "application/json";
    const session = JSON.parse(localStorage.getItem('user-session') || '{}');
    config.headers.token = session?.session?.token || "";
    return config;
});

export default apiInstance;